import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { selectIsAdmin, selectIsSuperAdmin } from '../../slices/profile';
import NotFound from '../../components/notFound';
import { useTranslation } from 'react-i18next';

const User = () => {
  const { t } = useTranslation();
  const isAdmin = useSelector(selectIsAdmin);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  return isAdmin || isSuperAdmin ? (
    <Outlet />
  ) : (
    <NotFound description={t('no_permission')} />
  );
};

export default User;
